import ComingSoon from "@/components/ComingSoon";
import UnderConstructionSvg from "@/components/UnderConstructionSvg";

export default function CompliancePage() {
  return <ComingSoon featureName="Under Construction" description="Privilege elevation rules and compliance management. This feature requires backend Compliance APIs." illustration={<UnderConstructionSvg />} />;
}
